import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Minimal%20artistic%20fashion%20composition%20with%20carefully%20placed%20garments%20accessories%20and%20textured%20fabrics%20on%20warm%20cream%20marble%20studio%20surface%2C%20soft%20diffused%20Mediterranean%20natural%20light%20from%20large%20window%2C%20elegant%20editorial%20product%20photography%2C%20terracotta%20sage%20green%20sand%20color%20palette%2C%20clean%20sophisticated%20composition&width=1800&height=1200&seq=itaobuy-hero-v2&orientation=landscape"
          alt="Itaobuy Spreadsheet shopping elegante italiano"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 pt-20 pb-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="max-w-2xl">
            <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-[1.05] tracking-tight">
              Itaobuy<br />
              Spreadsheet
            </h1>
            <p className="font-heading text-3xl md:text-4xl lg:text-5xl text-white/80 font-light italic mt-4 md:mt-6">
              La Guida Definitiva
            </p>
            <p className="font-heading text-3xl md:text-4xl lg:text-5xl text-white/60 font-light mt-1">
              2026
            </p>

            {/* Quick Answer Box */}
            <div className="mt-8 md:mt-12 bg-foreground-950/70 backdrop-blur-sm rounded-lg p-5 md:p-6 max-w-lg border border-white/10">
              <p className="text-xs font-semibold text-accent-400 uppercase tracking-wider mb-2">Quick Answer</p>
              <p className="text-sm font-medium text-white/90 mb-1.5">Cos&apos;&egrave; Itaobuy Spreadsheet?</p>
              <p className="text-sm text-white/70 leading-relaxed">
                Itaobuy Spreadsheet &egrave; una raccolta organizzata di informazioni prodotto che aiuta gli utenti a trovare categorie e articoli in modo pi&ugrave; efficiente, offrendo accesso rapido a migliaia di referenze moda.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-8 py-3.5 rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-bag-3-line mr-2 text-base"></i>
                Buy It Now
              </a>
              <Link
                to="/guida-completa"
                className="inline-flex items-center justify-center px-8 py-3.5 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line mr-2 text-base"></i>
                Leggi la Guida Completa
              </Link>
            </div>

            {/* Scroll indicator */}
            <div className="mt-16 flex items-center gap-2 text-white/50 text-xs">
              <i className="ri-arrow-down-line animate-bounce"></i>
              <span>Scorri per esplorare</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}